export enum ESkillDocumentTypes {
  GROUP = 1,
  INDIVIDUAL = 2
}
